// @flow
/**
 * @module Actions/Avaluo
 * @desc Actions for Avaluo
 */
import { ActionTypes } from '../utils/constants';

/**
 * Fetch test drive info request
 * @returns {Object}
 */
export function fetchAvaluosRequest(properties) {
  return {
    type: ActionTypes.FETCH_AVALUOS_REQUEST,
    payload: properties
  };
}

/**
 * Fetch test drive info success
 * @param {Object} info
 * @returns {Object}
 */
export function fetchAvaluosSuccess(options) {
  return {
    type: ActionTypes.FETCH_AVALUOS_SUCCESS,
    payload: { options },
  };
}

/**
 * Fetch test drive info failure
 * @returns {Object}
 */
export function fetchAvaluosFailure() {
  return {
    type: ActionTypes.FETCH_AVALUOS_FAILURE,
  };
}

/**
 * Fetch test drive info success
 * @param {Object} data
 * @returns {Object}
 */
export function getAvaluoSuccess(data) {
  return {
    type: ActionTypes.GET_AVALUO_SUCCESS,
    payload: data,
  };
}


/**
 * Fetch avaluo info request
 * @returns {Object}
 */
export function getAvaluoRequest(properties) {
  return {
    type: ActionTypes.GET_AVALUO_REQUEST,
    payload: properties
  };
}

/**
 * Fetch avaluo info failure
 * @returns {Object}
 */
export function getAvaluoFailure() {
  return {
    type: ActionTypes.GET_AVALUO_FAILURE,
  };
}


/**
 * Send email request
 * @returns {Object}
 */
export function sendAvaluoRequest(personalInfo, properties) {
  return {
    type: ActionTypes.SEND_AVALUO_REQUEST,
    payload: { personalInfo, properties }
  };
}

/**
 * Send email request
 * @returns {Object}
 */
export function sendAvaluoSuccess(personalInfo) {
  return {
    type: ActionTypes.SEND_AVALUO_SUCCESS,
  };
}